import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.offset = 0;
    this.firstClick = true;
    this.slug = this.data.get("slug");
    this.totalCount = parseInt(this.data.get("totalCount"), 10);
  }

  loadMore() {
    const limit = 5; // 一度に取得するイベントの数

    if (this.firstClick) {
      this.offset = 4;
      this.firstClick = false; // 次回以降は5を加算するように設定
    } else {
      this.offset += limit;
    }
    const url = `/p/${this.slug}/old_events?offset=${this.offset}&limit=${limit}`;

    $.ajax({
      url: url,
      type: "GET",
      dataType: "script",
      success: () => {
        if (this.offset + limit >= this.totalCount) {
          this.buttonTarget.style.display = "none";
        }
      },
      error: (xhr, status, error) => {
        console.error("Error loading more events:", status, error);
      },
    });
  }
}
